import { Component, OnInit, ViewChild } from '@angular/core';
import { PoBreadcrumb, PoDialogService, PoPageAction, PoPageFilter, PoPageListComponent, PoTableAction, PoTableColumn, PoTableColumnSpacing, PoTableComponent } from '@po-ui/ng-components';
import { PoPageDynamicTableCustomAction } from '@po-ui/ng-templates';
import { environment } from '../../../environments/environment';
import { SchemaBuilderService } from '../../core/menu/schema-builder.service';
import { HttpClient } from '@angular/common/http';
import { ListDataDto } from '../../core/common/list-data-dto';
import { Router } from '@angular/router';
import { ShortcutService } from '../../core/shortcut/shortcut.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-enquadramento-legal',
  templateUrl: './enquadramento-legal.component.html',
  styleUrls: ['./enquadramento-legal.component.css'],
  standalone: false
})
export class EnquadramentoLegalComponent implements OnInit {

  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoTableComponent;
  @ViewChild('pageListComponent', { static: true }) pageListComponent!: PoPageListComponent;


  isHideLoading = true;
  tableItens: any[] = [];
  columns: Array<PoTableColumn> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  moreItens: boolean = false;
  page: number = 1;
  pageSize: number = 15;
  filter: string = '';
  disclaimerGroup: any;
  private disclaimers: any[] = [];

  private shortcutSubscription: Subscription;
  public readonly filterSettings: PoPageFilter = {
    action: this.filterAction.bind(this),
    //advancedAction: this.advancedFilterActionModal.bind(this),
    placeholder: 'Pesquisar'
  };

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/enquadramento-legal`;

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Dados de Processamento' },
      { label: 'Configurações' },
      { label: 'Enquadramento Legal', link: '/enquadramento-legal' }
    ]
  };

  readonly pageActions: Array<PoPageAction> = [
    {
      label: 'Novo Enquadramento Legal',
      action: () => this.router.navigate(['/enquadramento-legal-edit']),
      icon: 'an an-plus'
    },
    {
      label: 'Atualizar',
      action: () => this.resetTable(),
      icon: 'an an-arrows-clockwise'
    }
  ];
  readonly actions: PoTableAction[] = [
    {
      label: 'Editar Registro',
      action: this.edit.bind(this),
      icon: 'an an-pencil',
      type: 'default'
    },
    {
      label: 'Deletar Registro',
      action: this.confirmDelete.bind(this),
      icon: 'an an-trash',
      type: 'danger',
      separator: true
    }
  ];

  constructor(private readonly schemaBuilderService: SchemaBuilderService,
    private readonly poDialogService: PoDialogService,
    private readonly shortcutService: ShortcutService,
    private readonly router: Router,
    private readonly http: HttpClient) {
    this.schemaBuilderService.getTableSchemaNew('enquadramento-legal').subscribe((data) => {
      this.columns = data;
    });

    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault();
        this.router.navigate(['/enquadramento-legal-edit'])
      }
      else if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        this.pageListComponent.filterInput.nativeElement.focus();
      }
    });

  }

  ngOnInit() {
    this.disclaimerGroup = {
      title: 'Filtros:',
      disclaimers: [],
      change: this.onChangeDisclaimer.bind(this),
      remove: this.onClearDisclaimer.bind(this)
    };
    this.loadMore();
  }

  populateDisclaimers(filters: Array<any>) {
    const property = filters.length > 1 ? 'advanced' : 'search';
    this.disclaimers = filters.map(value => ({ value, property }));

    if (this.disclaimers && this.disclaimers.length > 0) {
      this.disclaimerGroup.disclaimers = [...this.disclaimers];
    } else {
      this.disclaimerGroup.disclaimers = [];
    }
  }
  filterAction(labelFilter: string | Array<string>) {
    const filter = typeof labelFilter === 'string' ? [labelFilter] : [...labelFilter];
    this.populateDisclaimers(filter);
    this.filter = filter.toString();
    this.loadMore(true);
  }
  confirmDelete(item: any) {
    this.poDialogService.confirm({
      title: 'Exclusão de Registros',
      message: `Deseja realmente excluir o item selecionado?`,
      confirm: () => this.remove(item)
    });

  }
  remove(item: any) {
    this.isHideLoading = false;
    this.http.delete(`${this.serviceApi}/${item.id}`).subscribe(() => {
      this.dynamicTable.removeItem(item);
      this.isHideLoading = true;
    }, (error) => {
      console.error('Error deleting item:', error);
      this.isHideLoading = true;
    });
  }

  edit(item: any) {
    this.router.navigate(['/enquadramento-legal-edit', item.id]);
  }

  resetTable() {
    this.loadMore(true);
  }
  onChangeDisclaimer(disclaimers: any) {
    this.disclaimers = disclaimers;
    this.loadMore(true);
  }
  onClearDisclaimer(disclaimers: any) {
    if (disclaimers.removedDisclaimer.property === 'search') {
      this.pageListComponent.clearInputSearch();
    }
    this.disclaimers = [];
    this.filter = '';
    this.loadMore(true);
  }
  loadMore(reset: boolean = false): void {

    this.isHideLoading = false;
    if (reset) {
      this.page = 1;
      this.http.get<ListDataDto>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}`).subscribe((data) => {
        this.tableItens = [];
        this.tableItens = [...this.tableItens, ...data.items];
        this.moreItens = data.hasNext;
        this.page++;
        this.isHideLoading = true;
      }, (error) => {
        console.log(error);
        this.isHideLoading = true;
      });
    }
    else {
      this.http.get<ListDataDto>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}`).subscribe((data) => {
        this.tableItens = [...this.tableItens, ...data.items];
        this.moreItens = data.hasNext;
        this.page++;
        this.isHideLoading = true;

      }, (error) => {
        console.log(error);
        this.isHideLoading = true;

      });
    }

  }
}
